import { useQuery } from '@tanstack/react-query';

import { getSharesAvailableForOffering } from '@arrived/api_v2';
import { OfferingId, TotalAvailableSharesResponse } from '@arrived/models';

import { UseQueryOptions } from '../queries.utils';
import { offeringSharesAvailableKeyFn } from './sharesAvailable.keys';

/**
 * Returns how many shares are available for an Offering, does not take into account the number of shares a current user
 * has purchased.
 */
export function useSharesAvailableForOfferingQuery(
  offeringId?: OfferingId,
  options?: UseQueryOptions<TotalAvailableSharesResponse>
) {
  return useQuery(offeringSharesAvailableKeyFn(offeringId!), async () => getSharesAvailableForOffering(offeringId!), {
    ...options,
    staleTime: options?.staleTime ?? 10_000,
    enabled: (options?.enabled ?? true) && offeringId != null,
  });
}
